// in zones.js
import * as React from "react";
import {
  List, Datagrid, Edit, Create, SimpleForm, DeleteWithConfirmButton, TextField, EditButton,
  TextInput, required, useListContext, SelectArrayInput, ReferenceArrayInput, BooleanInput
} from 'react-admin';
import BookIcon from '@material-ui/icons/Book';
import { Form } from 'react-final-form';
import { Box, Button as CoreButton, InputAdornment } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import ContentFilter from "@material-ui/icons/FilterList";

import { exporter } from '../../functions/reactAdmin'

import { EditToolbar, EditActions } from './Default'


export const ZoneIcon = BookIcon;

const ZoneFilter = props => {
  return props.context === "button" ? (
    <ZoneFilterButton {...props} />
  ) : (
    <ZoneFilterForm {...props} />
  );
};

const ZoneFilterButton = () => {
  const { showFilter } = useListContext();
  return (
      <CoreButton
          size="small"
          color="primary"
          onClick={() => showFilter("main")}
          startIcon={<ContentFilter />}
      >
          Filter
      </CoreButton>
  );
};

const ZoneFilterForm = ({ open }) => {
  const {
      displayedFilters,
      filterValues,
      setFilters,
      hideFilter,
  } = useListContext();

  if (!displayedFilters.main) return null;

  const onSubmit = values => {
      if (Object.keys(values).length > 0) {
          setFilters(values);
      } else {
          hideFilter("main");
      }
  };

  const resetFilter = () => {
      setFilters({}, []);
  };

  return (
      <div>
      <Form onSubmit={onSubmit} initialValues={filterValues}>
          {({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
              <Box mt={8} />
              <Box display="flex" alignItems="flex-end" mb={1}>
              <Box component="span" mr={3}>
                <BooleanInput source="is_active" label="เปิดใช้งาน" alwaysOn />
              </Box>
              <Box component="span" mr={2}>
                  {/* Full-text search filter. We don't use <SearchFilter> to force a large form input */}
                  <TextInput
                  resettable
                  helperText={false}
                  source="name"
                  label="Search ชื่อ"
                  InputProps={{
                      endAdornment: (
                      <InputAdornment>
                          <SearchIcon color="disabled" />
                      </InputAdornment>
                      )
                  }}
                  />
              </Box>
              <Box component="span" mr={2} mb={1.5}>
                  <CoreButton variant="outlined" color="primary" type="submit">
                  Filter
                  </CoreButton>
              </Box>
              <Box component="span" mb={1.5}>
                  <CoreButton variant="outlined" onClick={resetFilter}>
                  Close
                  </CoreButton>
              </Box>
              </Box>
          </form>
          )}
      </Form>
      </div>
  );
};

export const ZoneList = (props) => (
  <List {...props} filters={<ZoneFilter />} exporter={exporter}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="is_active" label="เปิดใช้งาน"/>
      <TextField source="name" />
      <EditButton basePath="/zones" />
       <DeleteWithConfirmButton undoable={false}/>
    </Datagrid>
  </List>
);

const ZoneTitle = ({ record }) => {
  return <span>Zone {record ? `"${record.name}"` : ''}</span>;
};

export const ZoneEdit = (props) => (
  <Edit undoable={false} actions={<EditActions />} title={<ZoneTitle />} {...props}>
    <SimpleForm toolbar={<EditToolbar />}>
      <TextInput disabled source="id" />
      <BooleanInput label="เปิดใช้งาน" source="is_active"/>
      <TextInput source="name" validate={required()}/>
      <ReferenceArrayInput label="จังหวัด" source="province_ids" reference="provinces" perPage={80} sort={{field: 'id', order: 'ASC'}} fullWidth>
        <SelectArrayInput source="name" validate={required()}/>
      </ReferenceArrayInput>
    </SimpleForm>
  </Edit>
);

export const ZoneCreate = (props) => (
  <Create title="Create a Zone" actions={<EditActions />} {...props}>
    <SimpleForm>
      <TextInput source="name" validate={required()}/>
      <BooleanInput label="เปิดใช้งาน" source="is_active" defaultValue={true}/>
      <ReferenceArrayInput label="จังหวัด" source="province_ids" reference="provinces" perPage={80} sort={{field: 'id', order: 'ASC'}} fullWidth>
        <SelectArrayInput source="name" validate={required()}/>
      </ReferenceArrayInput>
    </SimpleForm>
  </Create>
);